<template>
  <div
    id="fetched-content-list"
    class="flex-fill h-100 overflow-auto"
  >
    <header
      class="px-5 py-4 m-0 bg-white d-flex"
      v-if="!isLoading"
    >
      <h4 class="m-0">
        Articles
      </h4>
      <label
        class="custom-switch"
        v-if="false"
      >
        <input
          type="checkbox"
          name="custom-switch-checkbox"
          class="custom-switch-input"
          v-model="allShared"
          @change="toggleSharedAll"
        >
        <span class="custom-switch-indicator" />
        <span class="custom-switch-description">Share All</span>
      </label>
      <span class="ml-auto">
        <b-button
          size="sm"
          variant="link"

          v-if="filterQuery!=''"
          @click="clearSearch()"
        >
          Reset
          <i class="fa-light fa-xmark ml-1" />
        </b-button>
        <b-button
          size="sm"
          @click="visible = !visible"
          v-if="showFilters"
        >
          Filters
          <i class="fal fa-search" />
        </b-button>
        <ArticlesActions
          v-if="showArticlesActions"
          @contentScrapeUpdate="contentScrapeUpdate"
          @selectOnlyDraft="selectOnlyDraft"
          @approveDraftItems="approveDraftItems"
          :view-type="viewType"
        />
      </span>
    </header>
    <b-collapse
      id="collapse-2"
      class="border-bottom"
      v-model="visible"
    >
      <b-row class="m-3">
        <b-col>
          <b-form-group
            id="search-fieldset"
            label="Search by headline"
            label-class="form-label"
            label-for="filter-search"
          >
            <div class="row gutters-xs">
              <div class="col">
                <b-form-input
                  id="filter-search"
                  v-model="search"
                  type="text"
                  class="form-control"
                  placeholder="Search for..."
                  autocomplete="off"
                  @keyup.enter="searchForTerm()"
                />
              </div>
              <span class="col-auto">
                <label class="selectgroup-item">
                  <input
                    type="radio"
                    v-model="sortBy"
                    name="sortBy"
                    value="title-asc"
                    class="selectgroup-input"
                  >
                  <span class="selectgroup-button selectgroup-button-icon">
                    <i class="fas fa-sort-alpha-down" />
                  </span>
                </label>
              </span>
              <span class="col-auto">
                <label class="selectgroup-item">
                  <input
                    type="radio"
                    v-model="sortBy"
                    name="sortBy"
                    value="title-desc"
                    class="selectgroup-input"
                  >
                  <span class="selectgroup-button selectgroup-button-icon">
                    <i class="fas fa-sort-alpha-up" />
                  </span>
                </label>
              </span>
            </div>
          </b-form-group>

          <b-form-group
            id="search-fieldset"
            label="Filter by state"
            label-class="form-label"
            label-for="filter-search"
          >
            <div class="row gutters-xs">
              <div class="col">
                <b-form-select
                  class="p-0"
                  v-model="searchStateSelected"
                  :options="searchStateOptions"
                  multiple
                  :select-size="4"
                />
              </div>
              <span class="col-auto">
                <label class="selectgroup-item">

                  <input
                    v-model="sortBy"
                    type="radio"
                    name="sortBy"
                    value="state-asc"
                    class="selectgroup-input"
                  >
                  <span class="selectgroup-button selectgroup-button-icon">
                    <i class="fas fa-sort-alpha-down" />
                  </span>
                </label>
              </span>
              <span class="col-auto">
                <label class="selectgroup-item">
                  <input
                    v-model="sortBy"
                    type="radio"
                    name="sortBy"
                    value="state-desc"
                    class="selectgroup-input"
                  >
                  <span class="selectgroup-button selectgroup-button-icon">
                    <i class="fas fa-sort-alpha-up" />
                  </span>
                </label>
              </span>
            </div>
          </b-form-group>

          <div class="row gutters-xs">
            <div class="col">
              <label class="form-label">
                Sort by updated date
              </label>
            </div>
            <span class="col-auto">
              <label class="selectgroup-item">
                <input
                  type="radio"
                  v-model="sortBy"
                  name="sortBy"
                  value="updatedDate-asc"
                  class="selectgroup-input"
                >
                <span class="selectgroup-button selectgroup-button-icon">
                  <i class="fas fa-sort-numeric-down" />
                </span>
              </label>
            </span>
            <span class="col-auto">
              <label class="selectgroup-item">
                <input
                  type="radio"
                  v-model="sortBy"
                  name="sortBy"
                  value="updatedDate-desc"
                  class="selectgroup-input"
                >
                <span class="selectgroup-button selectgroup-button-icon">
                  <i class="fas fa-sort-numeric-up" />
                </span>
              </label>
            </span>
          </div>

          <div
            class="btn-list d-flex mt-3"
          >
            <b-button
              variant="primary"
              class="ml-auto"
              @click="searchForTerm()"
            >
              Apply changes
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-collapse>
    <div
      v-if="showPendingArticles"
      class="flex-fill content-list-wrapper"
    >
      <div
        v-if="isLoading"
        class="h-100 align-items-center d-flex justify-content-center card-body"
      >
        <div class="loader mx-auto" />
      </div>
      <ShowcaseContentItem
        v-else-if="pendingArticles.length !== 0"
        v-for="(article, index) in pendingArticles"
        :key="index"
        :id="index"
        :view-type="viewType"
        :content-set="article"
        :edited="article.edited"
        :status="article.status"
        :content-item-id="article.encodedExternalId"
        @selectItem="selectItem"
        :active="isActive(article.encodedExternalId)"
        :comments-count="totalComments(article.encodedExternalId)"
        @updateContentItems="updateContentItems"
      />
    </div>
    <div
      v-else-if="!isLoading"
      class="px-5 py-3"
    >
      No items in list.
    </div>
    <div
      class="list-item-pagination border-top col"
      v-if="showPagination"
    >
      <base-pagination
        class="pt-3"
        :items-count="totalItems"
        :current-page.sync="currentPage"
        :per-page-selected.sync="perPageSelected"
        items-name="Items"
        :hide-page-select="true"
      />
    </div>
  </div>
</template>

<script>
import {
  mapActions, mapState, mapMutations, mapGetters,
} from 'vuex';
import * as contentTypes from '@/modules/content/store/types';

import ShowcaseContentItem from '@/modules/showcase/components/ShowcaseContentItem';
import ArticlesActions from '@/modules/content/components/ArticlesActions';
import BasePagination from '@/components/BasePagination.vue';

export default {
  name: 'ShowcaseContentList',
  components: {
    BasePagination,
    ShowcaseContentItem,
    ArticlesActions,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: true,
    },
    contentItems: {
      type: Array,
      default: () => [],
    },
    commentsCounts: {
      type: Object,
      default: () => {},
    },
    viewType: {
      type: String,
      default: 'Editor',
    },
    selectedItem: {
      type: String,
      default: '0',
    },
  },
  data() {
    return {
      currentPage: 1,
      perPageSelected: 30,
      liveArticles: [],
      archivedArticles: [],
      sortBy: '',
      sortDesc: false,
      search: '',
      searchStateOptions: ['Published', 'Paused', 'Draft', 'Approval'],
      searchStateSelected: [],
      visible: false,
      allShared: false,
    };
  },
  computed: {
    ...mapState('content', [
      'totalItems',
      'creative',
      'page',
      'totalPages',
      'feedTotalCount',
      'sharedCount',
      'mode',
    ]),
    ...mapGetters('content', [
      contentTypes.GET_CREATIVES_CARROUSEL_COVERED,
    ]),
    pendingArticles() {
      // if (this.isEditor) return this.items;
      return this.contentItems;
    },
    showPendingArticles() {
      // if (this.isEditor) return this.items.length !== 0;
      return this.contentItems.length !== 0;
    },
    showFilters() {
      return this.viewType === 'Editor' || this.viewType === 'Showcase';
    },
    showPagination() {
      return this.viewType === 'Editor' || this.viewType === 'Showcase';
    },
    showArticlesActions() {
      return this.viewType === 'Editor' || (this.viewType === 'Showcase'
      && this.mode === 'SHARER');
    },
    filterQuery() {
      let query = '';
      if (this.search) {
        query = `${query}&search=${encodeURIComponent(this.search)}`;
      }
      if (this.sortBy !== '') {
        const split = this.sortBy.split('-');
        query = `${query}&sort=${split.join()}`;
      }
      if (this.searchStateSelected.length !== 0) {
        const selectedState = this.searchStateSelected.join().toUpperCase();
        query = `${query}&states=${selectedState}`;
      }
      return query;
    },
  },
  methods: {
    ...mapActions('content', [
      contentTypes.FETCH_FILTERED_FEED_CONTENT_ITEMS,
      contentTypes.TOGGLE_ALL_CONTENT_SHARED,
      contentTypes.SELECT_ONLY_DRAFT,
      contentTypes.APPROVE_DRAFT_ITEMS,
    ]),
    ...mapMutations('content', [
      contentTypes.SET_CURRENT_PAGE,
      contentTypes.SET_SEARCH_QUERY,
    ]),
    selectItem(id) {
      this.$emit('setContentItem', id);
      if (this.viewType === 'Showcase') {
        this.$router.replace({ query: { ...this.$route.query, selectedItem: id || undefined } });
      }
    },
    isActive(contentItemId) {
      return (this.selectedItem === contentItemId);
    },
    totalComments(id) {
      if (this.id === '') return null;
      const contentkey = Object.keys(this.commentsCounts)
        .find((key) => key === id);
      if (contentkey) return this.commentsCounts[contentkey].count;
      return null;
    },
    selectContentItem() {
      if (this.selectedItem !== 0) {
        this.selectItem(this.selectedItem);
        setTimeout(() => {
          const articleElement = document.getElementById(`article-${this.selectedItem}`);
          if (articleElement !== null) {
            articleElement.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'end' });
          } else if (this.contentItems.length > 0) {
            this.selectItem(this.contentItems[0].encodedExternalId);
          }
        }, 1800);
      } else if (this.contentItems.length > 0) {
        this.selectItem(this.contentItems[0].encodedExternalId);
      }
    },
    resetPage() {
      this.SET_CURRENT_PAGE(1);
      this.currentPage = 1;
    },
    async searchForTerm() {
      if (this.filterQuery === '') return;
      this.resetPage();
      await this.FETCH_FILTERED_FEED_CONTENT_ITEMS({ feedId: this.creative.feedId });

      if (this.viewType === 'Showcase') {
        this.$emit('updateArticleList');
        this.selectContentItem();
      } else {
        this.$emit('setContentList');
      }
      this.$root.$emit('bv::toggle::collapse', 'collapse-2');
    },
    async clearSearch() {
      this.search = '';
      this.sortBy = '';
      this.searchStateSelected = [];
      this.$router.replace({ query: { creativeKey: this.creative.creativeKey, currentPage: this.currentPage } });
      this.SET_SEARCH_QUERY('');
      this.resetPage();
      await this.FETCH_FILTERED_FEED_CONTENT_ITEMS({ feedId: this.creative.feedId });
      this.$emit('updateArticleList');
      this.selectContentItem();
      if (this.visible) this.visible = false;
    },
    async toggleSharedAll() {
      const payload = {
        allShared: this.allShared,
      };
      await this.TOGGLE_ALL_CONTENT_SHARED(payload);
      await this.FETCH_FILTERED_FEED_CONTENT_ITEMS({ feedId: this.creative.feedId });
      this.$emit('updateArticleList');
      this.selectContentItem();
    },
    contentScrapeUpdate() {
      this.clearSearch();
    },
    updateContentItems(updatedItem) {
      if (updatedItem) {
        const index = this.contentItems.findIndex((item) => (updatedItem.id === item.id));
        this.contentItems.splice(index, 1, updatedItem);
      } else {
        this.$emit('updateArticleList');
        this.selectContentItem();
      }
    },
    handleKeydown(e) {
      if (this.GET_CREATIVES_CARROUSEL_COVERED) {
        return;
      }
      const keyCode = e.key;
      if (keyCode === 'w' || keyCode === 's') {
        const articles = this.pendingArticles;
        const selectedArticle = articles.find((article) => article.encodedExternalId === this.$route.query.selectedItem);
        const currentIndex = selectedArticle ? articles.indexOf(selectedArticle) : -1;

        let indexToUpdate = currentIndex;
        if (keyCode === 'w' && currentIndex > 0) {
          indexToUpdate -= 1;
        }
        if (keyCode === 's' && currentIndex > -1 && currentIndex < articles.length - 1) {
          indexToUpdate += 1;
        }
        if (indexToUpdate !== currentIndex) {
          this.selectItem(articles[indexToUpdate].encodedExternalId);
        }
      }
    },
    async selectOnlyDraft() {
      await this.SELECT_ONLY_DRAFT();
      await this.FETCH_FILTERED_FEED_CONTENT_ITEMS({ feedId: this.creative.feedId });
      this.$emit('updateArticleList');
      this.selectContentItem();
    },
    async approveDraftItems() {
      await this.APPROVE_DRAFT_ITEMS(this.creative.feedId);
      this.updateArticlesAfterUpdate();
    },
    async updateArticlesAfterUpdate() {
      await this.FETCH_FILTERED_FEED_CONTENT_ITEMS({ feedId: this.creative.feedId });
      this.$emit('updateArticleList');
      this.selectContentItem();
    },
  },
  watch: {
    currentPage(value) {
      this.$router.push({ query: { ...this.$route.query, currentPage: value } });
      if (value !== this.page) {
        this.SET_CURRENT_PAGE(value);
        this.FETCH_FILTERED_FEED_CONTENT_ITEMS({ feedId: this.creative.feedId })
          .then(() => {
            this.$emit('updateArticleList');
            this.selectContentItem();
          });
      }
    },
    filterQuery(value) {
      this.SET_SEARCH_QUERY(value);
    },
  },
  created() {
    const {
      currentPage,
    } = this.$route.query;
    this.currentPage = parseInt(currentPage, 10) || this.page;
  },
  mounted() {
    this.selectContentItem();
    if (!process.server) {
      window.addEventListener('keydown', this.handleKeydown);
    }
  },
  beforeDestroy() {
    if (!process.server) {
      window.removeEventListener('keydown', this.handleKeydown);
    }
  },
};
</script>
<style>
.list-item-pagination {
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
  z-index: 2;
}
.content-list-wrapper {
  padding-bottom: 59px;
}
.fetched-list-item {
  border-radius: 0;
}
</style>
